import { useEffect, useState } from "react"
import { serviceGetAllUsers } from "../api/serviceApi";
import { toast } from "react-toastify";

export const useUsers = (enabled = true) => {
    const [users, setUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        let cancelled = false;
        const loadUsers = async () => {
            try {
                setLoadingUsers(true);
                const result = await serviceGetAllUsers();

                if (!cancelled) {
                    setUsers(Array.isArray(result) ? result : []);
                }
            } catch (error) {
                console.error("Error loading users: ", error);

                if (!cancelled) {
                    setUsers([]);
                    toast.error(error?.message || "Failed to load users.")
                }
            } finally {
                if (!cancelled) {
                    setLoadingUsers(false);
                }
            }
        };

        loadUsers();
        return () => {
            cancelled = true;
        }
    }, [enabled]);

    return { users, loadingUsers }
}